import React, { Fragment } from 'react';

import { figure, hoursBasis, longDate } from './contractorFormat';

import Badge from 'CommonComponents/Badge';
import TableRowSkeleton from 'CommonComponents/TableRowSkeleton';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

const COLUMNS = 8;

export default function VenueContractorsByDayTable({ rows, totals, loading, expanded, onToggle }) {
    return (
        <div className="inbud-table_wrapper">
            <table className="inbud-table tw-min-w-[60rem]">
                <thead>
                    <tr>
                        <th className="!tw-text-start">{$t('Date')}</th>
                        <th className="!tw-text-start">{$t('Day type')}</th>
                        <th className="!tw-text-start">{$t('Sessions')}</th>
                        <th>{$t('Packs')}</th>
                        <th>{$t('Peak headcount')}</th>
                        <th>{$t('Shifts')}</th>
                        <th>{$t('Hours')}</th>
                        <th>{$t('Cost')}</th>
                    </tr>
                </thead>
                <tbody>
                    {loading && <TableRowSkeleton rows={5} columns={COLUMNS} />}
                    {!loading && rows.map((day) => <DayRow key={day.date} day={day} show={!!expanded[day.date]} onToggle={() => onToggle(day.date)} />)}
                </tbody>
                {!loading && totals && (
                    <tfoot>
                        <tr>
                            <td>{$t('Total')}</td>
                            <td />
                            <td>{totals.days === 1 ? $t('1 day') : $t('{{count}} days', { count: totals.days })}</td>
                            <td className="inbud-numeric-cell">{figure(totals.packs)}</td>
                            <td className="inbud-numeric-cell">{$t('{{peak}} max', { peak: figure(totals.peak) })}</td>
                            <td className="inbud-numeric-cell">{figure(totals.shifts)}</td>
                            <td className="inbud-numeric-cell">{figure(totals.hours)}</td>
                            <td className="inbud-numeric-cell">{figure(totals.cost)}</td>
                        </tr>
                    </tfoot>
                )}
            </table>
        </div>
    );
}

function DayRow({ day, show, onToggle }) {
    return (
        <Fragment>
            <tr className="tw-cursor-pointer" onClick={onToggle}>
                <td className="tw-font-semibold tw-whitespace-nowrap">
                    {/* Enter / Space on the button fire a click that bubbles to the row's onClick. */}
                    <button type="button" aria-expanded={show} className="tw-flex tw-items-center tw-gap-x-1.5 tw-text-start tw-font-semibold">
                        {show ? <ChevronUpIcon className="tw-shrink-0" aria-hidden="true" /> : <ChevronDownIcon className="tw-shrink-0" aria-hidden="true" />}
                        <span>{longDate(day.date)}</span>
                    </button>
                </td>
                <td>{day.is_session ? <Badge variant="success">{$t('Session day')}</Badge> : <Badge variant="neutral">{$t('Non-session')}</Badge>}</td>
                <td>
                    {day.sessions.length === 0
                        ? '–'
                        : day.sessions.map((session, index) => (
                              <div key={index}>
                                  {session.name}{' '}
                                  <span className="tw-font-mono tw-text-charcoal-75">
                                      {session.start}–{session.end}
                                  </span>
                              </div>
                          ))}
                </td>
                <td className="inbud-numeric-cell">{figure(day.packs)}</td>
                <td className="inbud-numeric-cell">{figure(day.peak)}</td>
                <td className="inbud-numeric-cell">{figure(day.shifts)}</td>
                <td className="inbud-numeric-cell">{figure(day.hours)}</td>
                <td className="inbud-numeric-cell">{figure(day.cost)}</td>
            </tr>
            {show && (
                <Fragment>
                    <tr className="!tw-bg-white tw-text-xs tw-font-semibold tw-text-charcoal-75">
                        <td className="!tw-ps-8">{$t('Pack')}</td>
                        <td>{$t('Functional area')}</td>
                        <td>{$t('Hours basis')}</td>
                        <td />
                        <td className="tw-text-end">{$t('Peak')}</td>
                        <td className="tw-text-end">{$t('Shifts')}</td>
                        <td className="tw-text-end">{$t('Hours')}</td>
                        <td className="tw-text-end">{$t('Cost')}</td>
                    </tr>
                    {day.packs_detail.map((pack) => (
                        <tr key={pack.id} className="!tw-bg-white">
                            <td className="!tw-ps-8">{pack.name}</td>
                            <td>{pack.department?.name}</td>
                            <td className="tw-font-mono">{hoursBasis(pack.basis)}</td>
                            <td />
                            <td className="inbud-numeric-cell">{figure(pack.peak)}</td>
                            <td className="inbud-numeric-cell">{figure(pack.shifts)}</td>
                            <td className="inbud-numeric-cell">{figure(pack.hours)}</td>
                            <td className="inbud-numeric-cell">{figure(pack.cost)}</td>
                        </tr>
                    ))}
                </Fragment>
            )}
        </Fragment>
    );
}
